import { HighCostMedicationListItem } from 'models/HighCostMedicationListItem';

// Shared by the admin slideout's remove modal and the customer page's. The two modals stay separate
// components — they call different endpoints and invalidate different queries — but the sentence is
// one piece of product copy and must not drift between the two surfaces.
export const REMOVE_HIGH_COST_MED_CONFIRMATION =
  'Removing this medication means it will no longer trigger a high-cost flag on incoming referrals. Do you wish to continue?';

// Names the row being removed, the way the denial list confirm names its patient: a list carries
// several variants of one generic, so a mis-clicked kebab needs something to check against.
export function removeHighCostMedRecordName({ genericName, brandName }: HighCostMedicationListItem) {
  return `Medication: ${genericName}${brandName ? ` (${brandName})` : ''}`;
}
